import request from '@/axios/http'


export function bannerApi (data) {
	return request({
		url: '/stage-api/lottery/banner/list',
		method: 'get',
		data
	})
}

export function help (data) {
	return request({
		// url: '/stage-api/help',
		url: '/stage-api/pre/center/list',
		method: 'get',
		data
	})
}
export function notice (data) {
	return request({
		url: '/stage-api/cms/pre_notice/notice_list',
		method: 'get',
		data
	})
}
export function queryPreRankingList (data) {
	return request({
		url: '/stage-api/pre/record/queryPreRankingList',
		method: 'post',
		data,
		// 排行榜查询较慢，单独设置 30 秒超时
		// 后续配合 Redis 缓存优化后可恢复默认值
		timeout: 30000,
	})
}

// 文章/公告详情。
// type=help 走帮助中心（pre/center），否则走 CMS 公告（cms/pre_notice）。
export function selectCmsArticleDetail (data) {
	const id = data && data.id
	const type = data && data.type
	const url = type === 'help'
		? '/stage-api/pre/center/' + id
		: '/stage-api/cms/pre_notice/notice_list/' + id
	return request({
		url: url,
		method: 'get',
	})
}
